export default "__VITE_ASSET__DWpHwXqi__"